document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const drawer = document.querySelector('[data-mobile-menu]');
    const open = drawer.toggleAttribute('data-open');
    toggle.setAttribute('aria-expanded', String(open));
  }
  const close = event.target.closest('[data-menu-close]');
  if (close) {
    document.querySelector('[data-mobile-menu]')?.removeAttribute('data-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  }
});

function updateProductVariant(option) {
  const form = option.closest('form');
  if (!form) return;
  const price = form?.parentElement?.querySelector('[data-product-price]');
  const sku = form?.parentElement?.querySelector('[data-product-sku]');
  const variantInput = form?.querySelector('[data-variant-id-input]');
  const button = form?.querySelector('[name="add"]');
  if (variantInput) {
    variantInput.value = option.value;
    variantInput.dispatchEvent(new Event('input', { bubbles: true }));
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (sku) sku.textContent = option.dataset.sku || '';
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? (button.dataset.addToCartText || 'Add to Cart') : 'Sold out';
  }
  const productPage = form.closest('.product-page');
  const gallery = productPage?.querySelector('.product-gallery');
  if (gallery) {
    const items = Array.from(gallery.querySelectorAll('[data-product-media-id]'));
    let selectedMedia = option.dataset.mediaId
      ? gallery.querySelector(`[data-product-media-id="${CSS.escape(option.dataset.mediaId)}"]`)
      : null;
    if (!selectedMedia && option.dataset.variantTitle) {
      selectedMedia = items.find((item) => (item.dataset.mediaAlt || '').includes(option.dataset.variantTitle)) || null;
    }
    if (selectedMedia) {
      items.forEach((item) => item.classList.toggle('is-selected-variant', item === selectedMedia));
      gallery.prepend(selectedMedia);
    }
  }
  if (window.history?.replaceState) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  }
}

document.addEventListener('click', (event) => {
  const variantButton = event.target.closest('[data-variant-button]');
  if (!variantButton || variantButton.disabled) return;
  event.preventDefault();
  const group = variantButton.closest('.variant-swatches');
  group?.querySelectorAll('[data-variant-button]').forEach((button) => {
    const selected = button === variantButton;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });
  updateProductVariant(variantButton);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  updateProductVariant(select.options[select.selectedIndex]);
});
